import { render, staticRenderFns } from "./ReportDetail.vue?vue&type=template&id=cc15bb84&scoped=true"
import script from "./ReportDetail.vue?vue&type=script&lang=js"
export * from "./ReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportDetail.vue?vue&type=style&index=0&id=cc15bb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc15bb84",
  null
  
)

export default component.exports